// extracted by mini-css-extract-plugin
export default {"container":"NewsList_container__zellX","newsItem":"NewsList_newsItem__YClSf","date":"NewsList_date__Xt-z0"};